var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaptiveFinance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-captive-finance"
  }, "Captive Finance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-captive-finance"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9L12 4l8.5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9v1h16V9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5v7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5v7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5v7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5v7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5h18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptiveFinance);
export default __webpack_public_path__ + "static/media/captive-finance.6ad77616237d336babc71b2d04362559.svg";
export { ForwardRef as ReactComponent };